module.exports = __webpack_public_path__ + "img/Covatic_Logomark - Full color.3d4d1227.png";